import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import Icon from './Icon'
import style from './Tag.less'

class Tag extends Component {
    static propTypes = {
        display: PropTypes.func,
        size: PropTypes.string,
        position: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired
    }

    static defaultProps = {
        display: (v) => v
    }

    _remove(event) {
        const {onChange} = this.props

        event.preventDefault()
        onChange(null)
    }

    render() {
        const {display, size, position, value, onChange, ...other} = this.props
        const sizeClass = size && size.toLowerCase()
        const positionClass = position && position.toLowerCase()

        return value != null && (
            <a
                href=''
                className={cx(style.default, style[sizeClass], style[positionClass])}
                onClick={(e) => this._remove(e)}>
                {positionClass != 'right' && (
                    <Icon icon='cross' size='xs' />
                )}
                {display(value)}
                {positionClass == 'right' && (
                    <Icon icon='cross' size='xs' />
                )}
            </a>
        ) || null
    }
}

export default Tag


// WEBPACK FOOTER //
// ./lib/core/components/Tag.js